import { ReactNode } from 'react';
import classNames from 'classnames';
import { MessageBoxButtonProps, MessageBoxButtons } from '@/components/modals/MessageBoxButtons';

// a "standard" (from a certain moment) modal with (possibly) icon, header, body and buttons list

export type MessageBoxProps = {
  icon?: ReactNode;
  header: ReactNode;
  body: ReactNode;
  buttons?: MessageBoxButtonProps[];
  onClick?: (button: MessageBoxButtonProps) => void;
  dataTestId?: string;
  popupClassName?: string;
};

export function MessageBox(props: MessageBoxProps) {
  const hasIcon = !!props.icon;
  return (
    <div
      className={classNames('bg-white w-[328px] sm:w-[512px] p-8', props.popupClassName)}
      data-testid={props.dataTestId}
    >
      <div className="flex flex-col text-dark-grey-600">
        {hasIcon && <div className="flex flex-row justify-center mb-5">{props.icon}</div>}
        <h2 className={classNames('text-2xl font-medium mb-4', hasIcon ? 'text-center' : '')}>
          {props.header}
        </h2>
        {!hasIcon && <hr className="mb-3" />}
        <div className={classNames('pt-3', hasIcon ? 'text-center pb-8' : '')}>{props.body}</div>
        <MessageBoxButtons buttons={props.buttons} onClick={props.onClick} />
      </div>
    </div>
  );
}
